import { useState } from "react";
import { Popover, Spin, Tooltip } from "antd";
import { useFetchWorkerLogtimeHistoriesV2 } from "@lhd/hooks";
import { formatIsoInTokyo } from "@lhd/features/TrackingTime/workLogTimezone";
import { toFullWidth } from "@lhd/utility";
import type { TimeCellRendererParams } from "../type";
import { formatAttendanceHistory } from "../InlineAttendanceEditor/utility";
import { StylesContainerHistory } from "./styled";

interface IProps {
  showTooltipEditCount: boolean;
  editCount: number;
  params: TimeCellRendererParams;
  companyId?: string | number;
  workerId: number;
  date: string;
  workerLogtimeId?: number;
}

const CellHistory = ({
  showTooltipEditCount,
  editCount,
  params,
  companyId,
  workerId,
  date,
  workerLogtimeId,
}: IProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const historyParams =
    workerId > 0 && date && workerLogtimeId
      ? {
          company_id: companyId,
          worker_id: workerId,
          date,
          worker_logtime_id: workerLogtimeId,
        }
      : null;

  const { data, isLoading, isFetching } = useFetchWorkerLogtimeHistoriesV2(
    historyParams,
    isPopoverOpen,
  );

  const renderDetailHistory = () => {
    const histories = data?.histories ?? [];

    return (
      <Spin spinning={isLoading || isFetching}>
        <StylesContainerHistory className="container-attendance-editor-history">
          {histories?.map((history) => (
            <li key={history.id} className="attendance-history-item">
              <div>{formatAttendanceHistory(history)}</div>
              <div
                className="attendance-editor-history-meta"
                style={{ color: "#5e5e5e", fontSize: 12 }}
              >
                {history.changed_by_full_name || "修正者不明"} /{" "}
                {formatIsoInTokyo(history.created_at, "YYYY/MM/DD HH:mm")}
              </div>
            </li>
          ))}
        </StylesContainerHistory>
      </Spin>
    );
  };

  return (
    <Popover
      title={`修正履歴（${toFullWidth(data?.total ?? editCount)}件）`}
      content={renderDetailHistory()}
      trigger="click"
      onOpenChange={(open) => {
        setIsPopoverOpen(open && showTooltipEditCount);
      }}
      placement="right"
      open={showTooltipEditCount ? undefined : false}
    >
      <Tooltip
        open={isPopoverOpen ? false : showTooltipEditCount ? undefined : false}
        title={`修正履歴（${toFullWidth(editCount)}件）`}
      >
        <div
          role={showTooltipEditCount ? "button" : undefined}
          tabIndex={showTooltipEditCount ? 0 : undefined}
          onKeyDown={(event) => {
            if (
              showTooltipEditCount &&
              (event.key === "Enter" || event.key === " ")
            ) {
              event.preventDefault();
            }
          }}
          style={
            showTooltipEditCount ? { color: "#1890FF", cursor: "pointer" } : {}
          }
        >
          {params.value ?? ""}
        </div>
      </Tooltip>
    </Popover>
  );
};

export default CellHistory;
